import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-page-content wiki-page" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "addons-container" }
const _hoisted_4 = { class: "wiki-panel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WikiBreadCrumbs = _resolveComponent("WikiBreadCrumbs")!
  const _component_LocalizedTextWrapper = _resolveComponent("LocalizedTextWrapper")!
  const _component_LocaleLink = _resolveComponent("LocaleLink")!
  const _component_SchemaImage = _resolveComponent("SchemaImage")!
  const _component_WikiPlayCta = _resolveComponent("WikiPlayCta")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_WikiBreadCrumbs),
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('expansions.seoHeading')), 1),
    _createElementVNode("div", null, [
      _createVNode(_component_LocalizedTextWrapper, { keypath: "expansions.intro" })
    ]),
    _createElementVNode("nav", {
      class: "wiki-nav",
      "aria-label": _ctx.$t('wiki.title')
    }, [
      _createVNode(_component_LocaleLink, { to: { name: 'rules' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('wiki.rules')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, { to: { name: 'roles' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('wiki.roles')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, { to: { name: 'expansions' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('wiki.addons')), 1)
        ]),
        _: 1
      })
    ], 8, _hoisted_2),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('expansions.chooseTitle')), 1),
    _createElementVNode("p", null, [
      _createVNode(_component_LocalizedTextWrapper, { keypath: "expansions.chooseText" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_LocaleLink, {
        class: "addon",
        to: { name: 'lady_of_lake' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('addons.ladyOfLake')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('expansions.ladyText')), 1),
          _createVNode(_component_SchemaImage, {
            class: "addon-image",
            src: _ctx.getImagePathByID('features', 'lady_of_lake'),
            alt: _ctx.$t('addons.ladyOfLake'),
            description: _ctx.$t('addons.ladyOfLake')
          }, null, 8, ["src", "alt", "description"])
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, {
        class: "addon",
        to: { name: 'excalibur' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('addons.excalibur')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('expansions.excaliburText')), 1),
          _createVNode(_component_SchemaImage, {
            class: "addon-image",
            src: _ctx.getImagePathByID('features', 'excalibur'),
            alt: _ctx.$t('addons.excalibur'),
            description: _ctx.$t('addons.excalibur')
          }, null, 8, ["src", "alt", "description"])
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, {
        class: "addon",
        to: { name: 'plot_cards' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('addons.plotCards')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('expansions.plotCardsText')), 1),
          _createVNode(_component_SchemaImage, {
            class: "addon-image",
            src: _ctx.getImagePathByID('features', 'plot_cards'),
            alt: _ctx.$t('addons.plotCards'),
            description: _ctx.$t('addons.plotCards')
          }, null, 8, ["src", "alt", "description"])
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, {
        class: "addon",
        to: { name: 'lady_of_sea' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('addons.ladyOfSea')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('expansions.ladySeaText')), 1),
          _createVNode(_component_SchemaImage, {
            class: "addon-image",
            src: _ctx.getImagePathByID('features', 'lady_of_sea'),
            alt: _ctx.$t('addons.ladyOfSea'),
            description: _ctx.$t('addons.ladyOfSea')
          }, null, 8, ["src", "alt", "description"])
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, {
        class: "addon",
        to: { name: 'trapper' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t('trapper.name')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('expansions.trapperText')), 1),
          _createVNode(_component_SchemaImage, {
            class: "addon-image",
            src: _ctx.getImagePathByID('features', 'trapper'),
            alt: _ctx.$t('trapper.name'),
            description: _ctx.$t('trapper.name')
          }, null, 8, ["src", "alt", "description"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('expansions.compatibilityTitle')), 1),
      _createElementVNode("p", null, [
        _createVNode(_component_LocalizedTextWrapper, { keypath: "expansions.compatibilityText" })
      ])
    ]),
    _createVNode(_component_WikiPlayCta)
  ]))
}